import { useExperiment } from 'shared/experiment'

import { useDeusExMachina } from '~/domains/platform/infra/deus-ex-machina/hocs/with-deus-ex-machina'

export function useIsBffHomeKaravelaEnabled() {
  const { deusExMachina } = useDeusExMachina()
  const subjectId = deusExMachina?.subject?.id ?? ''
  const { isFeatureFlagEnabled, isLoading } = useExperiment(subjectId, 'cj-core-bff-stone-web-karavela')

  return { isKaravelaEnabled: isFeatureFlagEnabled, isKaravelaLoading: isLoading }
}
